export enum IconType {
  MaterialDesign = 'MaterialDesign',
  Image = 'Image',
  SVG = 'SVG'
}
